// src/firebase.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';


const firebaseConfig = {
  apiKey: "AIzaSyDFSGdr_kpLVEZ9893-bLrZrEW-sMtaiIA",
  authDomain: "prodactive-25950.firebaseapp.com",
  projectId: "prodactive-25950",
  storageBucket: "prodactive-25950.firebasestorage.app",
  messagingSenderId: "449071832231",
  appId: "1:449071832231:web:4b831d17917a7e414e0f82",
  measurementId: "G-R2TM3XFG9K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get service instances
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { db, analytics };